import NewsAndArticlesContainer from "./NewsAndArticlesContainer";
import NewsAndArticlesStore from "./NewsAndArticlesStore";

export default NewsAndArticlesStore(NewsAndArticlesContainer);